import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left accessibility-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "learn-more-about-pdf-accessibility"
    }}>{`Learn more about PDF accessibility`}</h2>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='light' className="useCaseCard-doc-gen" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://www.adobe.com/accessibility/pdf/pdf-accessibility-overview.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "604px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a31ebe11f2238be2dea9a9259b33bc63/5530d/8_PDF_Accessibility_101_Image.webp 320w", "/document-services/static/a31ebe11f2238be2dea9a9259b33bc63/88e19/8_PDF_Accessibility_101_Image.webp 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a31ebe11f2238be2dea9a9259b33bc63/8980b/8_PDF_Accessibility_101_Image.jpg 320w", "/document-services/static/a31ebe11f2238be2dea9a9259b33bc63/8f4fd/8_PDF_Accessibility_101_Image.jpg 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a31ebe11f2238be2dea9a9259b33bc63/8f4fd/8_PDF_Accessibility_101_Image.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "pdf-accessibility-101"
    }}>{`PDF Accessibility 101`}</h2>
    <p>{`Combining PDF file format accessibility features with Adobe Acrobat and Adobe Reader allow universal access to documents.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='light' className="useCaseCard-doc-gen" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://helpx.adobe.com/acrobat/using/creating-accessible-pdfs.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "604px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5bb7a0cc2b5ce9c6a44b685a3c640947/5530d/8_Creating_accessible_PDFs_Image.webp 320w", "/document-services/static/5bb7a0cc2b5ce9c6a44b685a3c640947/88e19/8_Creating_accessible_PDFs_Image.webp 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5bb7a0cc2b5ce9c6a44b685a3c640947/8980b/8_Creating_accessible_PDFs_Image.jpg 320w", "/document-services/static/5bb7a0cc2b5ce9c6a44b685a3c640947/8f4fd/8_Creating_accessible_PDFs_Image.jpg 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/5bb7a0cc2b5ce9c6a44b685a3c640947/8f4fd/8_Creating_accessible_PDFs_Image.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "creating-accessible-pdfs"
    }}>{`Creating accessible PDFs`}</h2>
    <p>{`Create accessible PDFs by following the steps outlined in this workflow.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='light' className="useCaseCard-doc-gen" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/document-cloud-learn/acrobat-learning/advanced-tasks/accessibility-series/accessibility-series.html?"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "604px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/b3467104aeafeebacd31a77a00e9ea44/5530d/8_Acrobat_Accessibility_Webinar_Series.webp 320w", "/document-services/static/b3467104aeafeebacd31a77a00e9ea44/88e19/8_Acrobat_Accessibility_Webinar_Series.webp 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/b3467104aeafeebacd31a77a00e9ea44/8980b/8_Acrobat_Accessibility_Webinar_Series.jpg 320w", "/document-services/static/b3467104aeafeebacd31a77a00e9ea44/8f4fd/8_Acrobat_Accessibility_Webinar_Series.jpg 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/b3467104aeafeebacd31a77a00e9ea44/8f4fd/8_Acrobat_Accessibility_Webinar_Series.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "acrobat-accessibility-webinar-series"
    }}>{`Acrobat Accessibility webinar series`}</h2>
    <p>{`Watch our six-part webinar series and follow along using practice files to expand your accessibility knowledge.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      